/**
 * Simple window ponyfill
 * Exports window if available, otherwise a mock object for SSR/testing
 */

const mockWindow = {
  innerWidth: 1024,
  confirm: () => true,
  open: () => null,
  location: {
    origin: 'http://localhost:3000',
    href: 'http://localhost:3000',
  },
  navigator: {
    clipboard: {
      writeText: () => Promise.resolve(),
    },
  },
}

export const windowPonyfill = typeof window === 'object' ? window : mockWindow
